
<template>
  <div class="forwardUpload">
    <div class="upload" v-if="saveBtn">
      <div class="sel">
        <Poptip trigger="hover" word-wrap content="" transfer offset="2">
          <Icon type="ios-alert-outline" color="red" style="marginTop:-4px" />
          <div slot="content" v-html="this.uploadTipTxt">
          </div>
        </Poptip>
        <label>附件上传项大类 :&nbsp;</label>
        <Select v-model="select1Data" @on-change="accessorySelect" @on-clear="select1Clear" transfer clearable>
          <Option v-for="(item , index) in upload1Item" :key="index" :value="item.limitval">{{item.limitdesc}}</Option>
        </Select>
      </div>
      <div class="sel">
        <label>附件上传项明细 :&nbsp;</label>
        <Select v-model="select2Data" @on-open-change="select2Open" transfer clearable>
          <Option v-for="(item , index) in upload2Item" :key="index" :value="item.limitval">{{item.limitdesc}}</Option>
        </Select>
      </div>
      <div class="upl" v-if="uplShow">
        <label>附件上传 :&nbsp;</label>
        <Upload action="/p/cs/batchUpload" name="files" :before-upload="beforeUpload"  :accept="acceptFile" :on-success="onSuccess" :on-error="onError" :on-remove="onRemove" :data="uplData">
          <span class="uplFile">
            <Icon type="md-cloud-upload" />上传附件
          </span>
        </Upload>
      </div>
    </div>
    <div class="pageNation">
      <Page :total="page.total" show-sizer :page-size-opts="page.pageSizeOpts" :current="page.current" :page-size="page.pageSize" @on-change="pageChange" @on-page-size-change="pageSizeChange" />
      <div class="button">
        <span v-if="saveBtn" @click="save({detail:{type:'saveWithWorwardUpload'}})">【保存】</span>
        <span v-if="deleteBtn" @click="delItem">【删除明细】</span>
        <!-- <span>【导入】</span>
        <span @click="exportFile">【导出】</span>-->
      </div>
    </div>
    <div class="table">
      <Table :columns="tableConfig.columns" :data="tableConfig.data" @on-selection-change="onSelectChange"></Table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import uploadDalog from './uploadDalog';
Vue.component('uploadDalog', uploadDalog);
const mapping = {
  "CL_C_CUST_AUTHENTICATION": { //客户认证申请
    tableName: "CL_C_CUST_AUTHENTICATION_ANNEX_ITEM",
    tableId: 249130108,
    refcolId: 1700804579,
  },
  "CL_C_CUST_CHANGE": { //客户更码申请
    tableName: "CL_C_CUST_CHANGE_ANNEX_ITEM",
    tableId: 249130089,
    refcolId: 1700803382,
  },
  "CL_C_CUST_COLSE_APPLY": { //客户关户申请
    tableName: "CL_C_CUST_COLSE_APPLY_ANNEX_ITEM",
    tableId: 249130078,
    refcolId: 1700803127,
  },
  "CL_C_CUST_GRADE_CHG": { //客户评级变更
    tableName: "CL_C_CUST_GRADE_CHG_ANNEX_ITEM",
    tableId: 249130277,
    refcolId: 1700815537,
  },
  "CL_C_CUST_OPEN": { //客户开户申请
    tableName: "CL_C_CUST_OPEN_ANNEX_ITEM",
    tableId: 249130069,
    refcolId: 1700802868,
  },
  "CL_C_CUST_OPEN_EXPAND": { //6	客户拓展申请
    tableName: "CL_C_CUST_OPEN_ANNEX_ITEM",
    tableId: 249130100,
    refcolId: 1700802868,
  },
  "CL_C_CUST_RELAT_CHG": { //客户关系变更
    tableName: "CL_C_CUST_RELAT_CHG_ANNEX_ITEM",
    tableId: 249130082,
    refcolId: 1700803330,
  },
  "CL_C_STORE_AUTHENTICATION": { //店铺认证申请
    tableName: "CL_C_STORE_AUTHENTICATION_ANNEX_ITEM",
    tableId: 249130163,
    refcolId: 1700807373,
  },
  "CL_C_STORE_CLOSE": { //店铺关闭申请
    tableName: "CL_C_SHOP_CLOSE_ANNEX_ITEM",
    tableId: 249130170,
    refcolId: 1700841021,
  },
  "V_CL_C_SPECIAL_STORE_CLOSE": { //特卖场关闭
    tableName: "CL_C_STORE_CLOSE_ANNEX_ITEM",
    tableId: 249130628,
    refcolId: 1700840976,
  },
  "CP_C_STORE_PROPERTY_CHG": { //店铺关系变更
    tableName: "CP_C_STORE_PROPERTY_CHG_ANNEX_ITEM",
    tableId: 249130171,
    refcolId: 1700841003,
  },
  "CL_C_STORE_IMPROVE": { //店铺整改申请
    tableName: "CL_C_STORE_IMPROVE_ANNEX_ITEM",
    tableId: 249130122,
    refcolId: 1700805760,
  },
  "CL_C_STORE_OPEN": { //店铺新开申请
    tableName: "CL_C_STORE_OPEN_ANNEX_ITEM",
    tableId: 249130169,
    refcolId: 1700806960,
  },
  "CP_C_STORE_INFO_CHG": { //店铺资料变更
    tableName: "CP_C_STORE_INFO_CHG_ANNEX_ITEM",
    tableId: 249130166,
    refcolId: 1700807925,
  },
  "CP_C_STORE_RENEW": { //店铺续约申请
    tableName: "CP_C_STORE_RENEW_ANNEX_ITEM",
    tableId: 249130173,
    refcolId: 1700808657,
  },
  "V_CL_C_STORE_OPEN_SPECIAL_MARKET": { //特卖场新开
    tableName: "CL_C_STORE_OPEN_ANNEX_ITEM",
    tableId: 249130522,
    refcolId: 1700806960,
  },
  "CL_C_VI_BASIC_COMMIT": { //店铺装修设计
    tableName: "CL_C_VI_BASIC_COMMIT",
    tableId: 249130640,
    refcolId: 1700841239,
  }
}
export default {
  name: 'forwardUpload',
  data() {
    return {
      saveBtn: true,
      deleteBtn: true,
      uplShow: true,
      page: {
        total: 1,
        start: 0,
        current: 1,
        pageSize: 10,
        pageSizeOpts: [1, 10, 20, 30, 50]
      },
      acceptFile: '.dwg,.xls,.pptx,.jpg,.pdf,.xlsx,.ppt,.msg,.doc,.png,.docx,.txt,.rar,.dxf,.dwl,.zip,.mp4,.eml,.bmp,.jpeg,.et,.rtf,.jfif,.xlsb,.pub,.exb,.webp,.tif,.csv',
      // formatFile:['dwg','xls','pptx','jpg','pdf','xlsx','ppt','msg','doc','png','docx','txt','rar','dxf','dwl','zip','mp4','eml','bmp','jpeg','et','rtf','jfif','xlsb','pub','exb','webp','tif','csv'],
      uploadItem: [],
      upload1Item: [],
      upload2Item: [],
      uploadTipTxt: '', //提示文案
      files: [],
      // selectData: '',
      select1Data: '',
      select2Data: '',
      uplData: {
        path: ''
      },
      tableConfig: {
        columns: [],
        data: [

        ]
      },
      onSelectChangeData: []
    }
  },
  created() {
    this.initData();
    this.getTableData();
    window.addEventListener('customizeClick', this.save);
  },
  activated() {
    this.refresh();
  },
  destroyed() {
    window.removeEventListener('customizeClick', this.save);
  },
  methods: {
    refresh() {  //刷新
      this.initData();
      this.getTableData();
      // this.selectData = undefined;
      this.select1Data = undefined;
      this.select2Data = undefined;

      this.uplShow = false;
      this.page.current = 1
      this.$nextTick(() => {
        this.uplShow = true;
        this.files = [];
        this.onSelectChangeData = []
      })
    },
    initData() {
      // console.log('userInfo :>> ', this.$store.state.global.userInfo);
      const { tableName, tableId, itemId } = this.$router.currentRoute.params;

      axios({
        url: '/p/cs/jflowCheckBtnIsHide',
        method: 'post',
        data: {
          table: tableName,
          tableId: tableId,
          objid: itemId == 'New' ? -1 : itemId,
          userid: this.$store.state.global.userInfo.id
        }
      }).then(res => {
        if (res.data.data.code == 0) {
          // console.log('jflowCheckBtnIsHide.res :>> ', res.data.data.data);
          let { deleteHide, saveHide } = res.data.data.data
          this.saveBtn = !saveHide;
          this.deleteBtn = !deleteHide;
        } else {
          this.$Message.error(res.data.data.message);
        }
      });

      this.uplData.path = `${mapping[tableName].tableName}/${itemId}/${new Date().getTime()}/`

      let formdata = new FormData();
      formdata.append('table', mapping[tableName].tableName);
      formdata.append('inlinemode', 'Y')
      //   this.uplData.path = `${this.$route.params.tableName}/${this.$route.params.itemId}/${new Date().getTime()}/`
      //   formdata.append('table', 'CL_C_VI_DESIGN_COMMIT');
      //   formdata.append('inlinemode', 'Y')
      axios({
        url: '/p/cs/inputForitem',
        method: 'post',
        data: formdata
      }).then(res => {
        if (res.data.code == 0) {
          // this.uploadItem = res.data.data.inpubobj.filter(item => item.colname == "UPLOAD_ITEM")[0].combobox;
          this.uploadItem = res.data.data.inpubobj;
          this.upload1Item = res.data.data.inpubobj.filter(item => item.colname == "UPLOAD_ITEM_SEC_LEVEL")[0].combobox;
          this.uploadTipTxt = res.data.data.inpubobj.filter(item => item.colname == "UPLOAD_ITEM_SEC_LEVEL")[0].comment
        }
      });
    },
    // 附件下拉选择
    select1Clear(){
      this.select2Data = undefined
      this.upload2Item = []
    },
    select2Open(type){
      if(type && !this.select1Data){
         this.$Message.warning('请先选择附件上传项大类');
      }
    },
    accessorySelect(){
      if(!this.select1Data) return;
      let newArr = []
      this.uploadItem[1].combobox.map(item => {
        this.uploadItem[1].webconf.filtercolval.map[this.select1Data].map(sl => {
          if(item.limitval == sl){
            newArr.push(item)
          }
        })
      })
      this.upload2Item = newArr
    },
    getTableData() {
      this.tableConfig.columns = [];
      let obj = {};
      obj['startindex'] = this.page.pageSize * (this.page.current - 1);
      obj['range'] = this.page.pageSize;
      obj['column_include_uicontroller'] = true;
      let formdata = new FormData();
      //   formdata.append('table', 'CL_C_VI_DESIGN_COMMIT');
      //   formdata.append('objid', this.$route.params.itemId);
      //   formdata.append('refcolid', 1700841239);
      //   formdata.append('searchdata', JSON.stringify(obj));
      const { tableName, itemId } = this.$router.currentRoute.params;
      formdata.append('table', mapping[tableName].tableName);
      formdata.append('objid', itemId == 'New' ? -1 : itemId);
      formdata.append('refcolid', mapping[tableName].refcolId);
      formdata.append('searchdata', JSON.stringify(obj));
      axios({
        url: '/p/cs/objectTableItem',
        method: 'post',
        data: formdata
      }).then(res => {
        if (res.data.code == 0) {
          // console.log('getTableData.datas :>> ', res.data.datas);
          let arr = [];
          res.data.datas.tabth.forEach(item => {
            if (item.colname !== 'ID') {
              let obj = {};
              obj['title'] = item.name;
              obj['key'] = item.colname
              arr.push(obj);
            } else {
              let obj = {};
              obj['type'] = 'selection';
              obj['name'] = item.name;
              obj['colname'] = item.colname
              arr.push(obj);
            }
          });
          this.page.total = res.data.datas.totalRowCount; //总条数
          this.page.start = res.data.datas.start; //开始条数
          this.page.pageSize = res.data.datas.defaultrange; //每页条数
          this.page.pageSizeOpts = res.data.datas.selectrange;
          this.tableConfig.columns = arr
          this.renderColumn(this.tableConfig.columns);
          let tempTableData = res.data.datas.row.map(item => {
            let obj = {};
            for (let key in item) {
              obj[key] = item[key].val;
            }
            return obj;
          });
          // console.log('tempTableData :>> ', JSON.parse(JSON.stringify(tempTableData)));
          this.tableConfig.data = tempTableData
        }
      })
    },
    beforeUpload(file){
      // console.log('file :>> ', file);
      if(file.name.includes(',')){
        this.$Modal.fcError({
          title: '错误',
          content: '文件名不支持英文逗号,',
          showCancel: false,
        })
        return false
      }else{
        return true
      }
    },
    onSuccess(res, file, filelist) {
      if (res.code == 0) {
        this.files = filelist;
        // console.log('filelist :>> ', filelist);
        // let data = '';
        // let formdata = new FormData();
        // data = this.files.map(res => {
        //   return res.response.data[0].UploadId;
        // });
        // formdata.append('uploadIds', data.join(','));
        // axios({
        //   url: '/p/cs/batchUploadProgress',
        //   method: 'post',
        //   data: formdata
        // }).then(res => {
        // })
      } else {
        // console.log('filelist :>> ', filelist);
        // console.log('file :>> ', file);
        let newFiles = filelist.filter(item => item.uid != file.uid)
        console.log('newFiles :>> ', newFiles);
        // this.$Message.warning(res.message);
        this.$Modal.fcError({
          title: '错误',
          content: res.message,
          showCancel: false,
        })
      }
    },
    onError(e) {
      // this.$Message.warning(e.message);
      this.$Modal.fcWarning({
        title: '提示',
        content: e.message,
        showCancel: false,
      })
    },
    onRemove(res, filelist) {
      this.files = filelist;
    },
    save(e) {
      // console.log("save.e.detail=>", e.detail);
      if (e.detail.type == 'refresh') {
        this.initData();
        this.getTableData();
        // this.refresh();
        // return
      }
      // console.log('this.files :>> ', this.files);
      if (e.detail.type == 'save') { //点击上面的保存时
        if (this.select1Data && this.select2Data && this.files.length > 0) {
          this.saveData()
        }
      }
      if (e.detail.type == 'saveWithWorwardUpload') { //点击附件的保存
        if (!this.select1Data || !this.select2Data || this.files.length == 0) {
          this.$Message.warning('附件上传项与附件上传不能为空!');
        } else {
          this.saveData()
        }
      }
    },
    saveData() {
      const { tableName, itemId } = this.$router.currentRoute.params;
      const mapTableName = mapping[tableName].tableName
      let arr = this.files.map(item => {
        return {
          name: item.response.data[0].Name,
          url: item.response.data[0].Url,
          Size: item.response.data[0].Size,
        }
      });
      let userInfo = this.$store.state.global.userInfo
      let param = {
        objid: itemId,
        table: tableName,
        fixcolumn: {},
        user: {
          userId: userInfo.id,
          userName: userInfo.name,
          userEName: userInfo.ename,
          clientId: userInfo.userenv.$AD_CLIENT_ID$,
          orgId: userInfo.userenv.$AD_ORG_ID$
        }
      }
      param.fixcolumn[mapTableName] = [{
        UPLOAD_ITEM_SEC_LEVEL: this.select1Data,
        UPLOAD_ITEM: this.select2Data,
        TYPE: JSON.stringify(arr),
        ID: -1
      }]
      axios({
        url: '/p/cs/annexItemSaveBySrv',
        method: 'post',
        data: param
      }).then(res => {
        // console.log('res :>> ', res);
        if (res.data.data.code == 0) {
          let msg = '附件保存成功'
          this.$Message.success(msg);
          this.refresh();
        } else {
          this.$Message.error('附件保存失败');
        }
      })
      // let data = {};
      // let arr = this.files.map(item => {
      //   let obj = {};
      //   obj['name'] = item.response.data[0].Name;
      //   obj['url'] = item.response.data[0].Url;
      //   obj['Size'] = item.response.data[0].Size;
      //   return obj;
      // });
      // const { tableName, itemId } = this.$router.currentRoute.params;
      // let mapTableName = mapping[tableName].tableName
      // data[mapTableName] = [{}];
      // data[mapTableName][0]['UPLOAD_ITEM'] = this.selectData;
      // data[mapTableName][0]['TYPE'] = JSON.stringify(arr);
      // data[mapTableName][0]['ID'] = -1;
      // let formdata = new FormData();
      // formdata.append('table', tableName);
      // formdata.append('objid', itemId);
      // formdata.append('data', JSON.stringify(data));
      // R3.network.post('/p/cs/objectSave', formdata).then(res => {
      //   if (res.data.code == 0) {
      //     this.$Message.success(res.data.message);
      //     this.refresh();
      //   } else {
      //     this.$Message.error(res.data.message);
      //   }
      // })
    },
    renderColumn(column) {
      column.forEach(item => {
        if (item.key == 'TYPE') {
          item['render'] = (h, params) => {
            if (!params.row.TYPE) return
            let str = JSON.parse(params.row.TYPE).map(item => {
              return `【${item.name}】`
            })
            return h('div', {
              style: {
                position: 'relative'
              }
            },
              [
                h('span', {
                }, str),
                h('Poptip', {
                  props: {
                    trigger: 'click',
                    transfer: true,
                    content: 'content'
                  },
                  scopedSlots: {
                    default: () => h('div', {
                      style: {
                        'padding-left': '10px',
                        'padding-right': '10px',
                      },
                      domProps: {
                        innerHTML: '<i class="iconfont iconbj_listedit" style="color: #2D8CF0; font-size: 16px"></i>'
                      },
                    }),
                    content: () => h('uploadDalog', {
                      props: {
                        uploadData: params.row
                      },
                      on: {
                        'refresh': () => {
                          this.refresh();
                        }
                      }
                    })
                  }
                })
              ])
          }
        }
        // console.log('column :>> ', column);
      })
    },
    onSelectChange(sel) {
      this.onSelectChangeData = sel;
    },
    delItem() {
      if (this.onSelectChangeData.length == 0) {
        this.$Message.warning('请选择删除项!');
        return;
      }
      this.$Modal.fcWarning({
        title: '提示',
        content: '确认执行删除?',
        showCancel: true,
        onOk: () => {
          // let obj = {};
          // obj['table'] = this.$route.params.tableName;
          // obj['objid'] = this.$route.params.itemId;
          // obj['isdelmtable'] = 'isdelmtable';
          // let data = {}
          // data['CL_C_VI_DESIGN_COMMIT'] = this.onSelectChangeData.map(item => item.ID);
          // obj['data'] = data;
          // R3.network.post('/p/cs/storeViAnnexDelete', R3.urlSearchParams(obj)).then(res => {

          const { tableName, itemId } = this.$router.currentRoute.params;
          const mapTableName = mapping[tableName].tableName
          const data = {}
          data[mapTableName] = this.onSelectChangeData.map(item => item.ID)

          const formdata = new FormData();
          formdata.append('table', tableName);
          formdata.append('objid', itemId);
          formdata.append('isdelmtable', false);
          formdata.append('data', JSON.stringify(data));
          R3.network.post('/p/cs/objectDelete', formdata).then(res => {
            if (res.data.code == 0) {
              this.$Message.success(res.data.message);
              this.refresh();
            } else {
              this.$Message.warning(res.data.message);
            }
          })
        }
      })
    },
    exportFile() {
      let data = {};
      let obj = {};
      obj['table'] = this.$route.params.tableName;
      obj['column_include_uicontroller'] = true;
      let fixedcolumns = {};
      fixedcolumns['ID'] = this.onSelectChangeData.length == 0 ? null : this.onSelectChangeData.map(item => item.ID);
      fixedcolumns['objectIds'] = `1700841239=${this.$route.params.itemId}`
      fixedcolumns['startindex'] = this.page.pageSize * (this.page.current - 1);
      fixedcolumns['range'] = this.page.pageSize;
      obj['fixedcolumns'] = fixedcolumns;
      data['searchdata'] = obj;
      data['filename'] = '装修设计-附件上传';
      data['filetype'] = '.xlsx';
      data['showColumnName'] = true;
      data['menu'] = '装修设计-附件上传';
      R3.network.post('/p/cs/export', R3.urlSearchParams(data)).then(res => {
        console.log(res);
      })
    },
    pageChange(val) {
      this.page.current = val;
      this.getTableData();
    },
    pageSizeChange(val) {
      this.page.pageSize = val;
      this.getTableData();
    }
  }
}
</script>

<style lang="less">
.forwardUpload {
  height: 500px;
  .upload {
    display: flex;
    background: #f8f8f8;
    .sel,
    .upl {
      white-space: nowrap;
      line-height: 26px;
      display: flex;
      width: 200px;
      margin-left: 50px;
      margin-top: 5px;
      margin-bottom: 5px;
      label:before {
        content: "*";
        color: red;
        margin-right: 2px;
      }
    }
    .upl {
      margin-left: 100px;
      .uplFile {
        cursor: pointer;
        color: #0f8ee9;
      }
    }
    .sel {
      .icon {
        color: red;
        font-size: 12px;
      }
    }
  }
  .pageNation {
    margin: 8px 0;
    display: flex;
    .button {
      color: #0f8ee9;
      margin-top: 9px;
      cursor: pointer;
    }
  }
  .ark-tooltip-popper .ark-tooltip-inner{
    line-height: 16px !important;
  }
}
</style>